import React, { useContext, useEffect, useMemo, useState } from 'react'
import LrDetailsPage from './LrDetailsPage';
import { deleteLrListData, getDataLrDetails } from '_services/accountsServices/lrServices';
import StorageService from 'utils/StorageServices/StorageServices';
import { fetchConsignorDetailsData } from '_services/accountsServices/consignorServices';
import { useNavigate } from 'react-router-dom';
import { actionPermission, utils } from 'helper';
import AtPartyPointModal from 'modals/AtPartyPointModal';
import PodRecievedModal from 'modals/PodRecievedModal';
import { UserContext } from 'context';
import { RiAddLargeFill } from 'react-icons/ri';
import { deletePodImage, getUserPermissionApi, podReceivedData, podStatusUpdateData, podUpdateDataService, uploadFiles } from '_services';
import toast from 'react-hot-toast';
import ContinuePodRecievedModal from 'modals/ContinuePodRecievedModal';
import EditPodStatus from 'modals/EditPodStatus';
import { getMaterialCategoryListData } from '_services/materialServices/materialCategoryServices';
import PermissionModal from 'modals/PermissionModal';
import { TimeLine } from 'modals/TimeLineEwayModal';
import { ButtonForIcon, CommonModal, CrossButton } from 'components';
import { BsFiletypeXlsx, BsFillFileEarmarkPdfFill, BsFillPrinterFill } from 'react-icons/bs';
import { FaRegImage, FaRegTrashCan } from 'react-icons/fa6';
import { RxCross2 } from 'react-icons/rx';
import { MdOutlineFileDownload, MdOutlineRemoveRedEye } from 'react-icons/md';
import { constant } from 'constants/constant';
import EbillExtentionModal from 'modals/EbillExtentionModal';
import UpdateLrDetailsUsingPod from 'modals/UpdateLrDetailsUsingPod';
import ImagePreview from './ImagePreview';
import LrFreight from './LrFreight';
import AddChargesForInvoice from 'modals/AddChargesForInvoice';
import AddClaimForInvoice from 'modals/AddClaimForInvoice';
import EditConsignorFInvoice from 'modals/EditConsignorFInvoce';
import { Images } from 'constants';
import EditConsignorFreight from 'modals/EditConsignorFreight';
import { FiEdit2 } from 'react-icons/fi';
import { HiPencil } from 'react-icons/hi2';
import InvoiceLrPodModal from 'modals/InvoiceLrPodModal';
import ConfirmModalFor from 'modals/ConfirmModalFor';
import Loading from 'pages/Loading';


const LrDetailModal = (props) => {
    const navigate = useNavigate();

    const { masterData, setLrDetialsFrom, lrPermissions, permissionModal, setPermissionModal, setUserSettingPermission, allMenu } = useContext(UserContext)
    let { isOpen, onClose, nextModal, hideEditButton = false, ewayBillStatusDetails = false, createTripBtn = false, callGetData = () => { } } = props;

    const [loading, setLoading] = useState(false);
    const [lrDetailsData, setLrDetailsData] = useState({});
    const [consignorDetailsData, setConsignorDetailsData] = useState({});
    const [isOpenPartyPoint, setIsOpenPartyPoint] = useState(false);
    const [isOpenPodReceived, setIsOpenPodReceived] = useState(false);
    const [continePodReceived, setContinePodReceived] = useState(false);
    const [isPodStatusEdit, setIsPodStatusEdit] = useState(false);
    const [materialCategoryList, setMaterialCategoryList] = useState([]);
    const [updateDetailsUsingPod, setUpdateDetailsUsingPod] = useState({});
    const [imagePreview, setImagePreview] = useState({})
    const [deletePodFiles, setDeletePodFiles] = useState({});
    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        messageType: null,
        templateId: null,
        templateData: {}
    });
    const [activeTab, setActiveTab] = useState("");
    const [isOpenCharge, setIsOpenCharges] = useState({ open: false, type: "" });
    const [isOpenClaim, setIsOpenClaim] = useState(false);
    const [editLrAmount, setEditLrAmount] = useState(false);
    const [isHandleRowData, setHandleRowData] = useState({})

    const [isLrDelete, setIsLrDelete] = useState(false);
    const [lrDeleteloading, setLrDeleteLoading] = useState(false);

    const [format, setFormats] = useState({
        lr_with_pod: 0,
        lr_id: ''
    })
    const [showBackModal, setShowBackModal] = useState(false);

    const childsUser = useMemo(() =>
        allMenu?.find((i) => i?.label === 'Trip'),
        [allMenu]
    );

    const getTableMaterialCategoryListData = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                limit: 100,
                offset: 1,
                search: '',
            }
            const res = await getMaterialCategoryListData(object);
            if (res?.responseCode == 200) {
                setMaterialCategoryList(res?.data?.material_categorys)
            }
        } catch (error) {
            // throw error;
        }
    }

    const getDetailsOfLrData = async (data) => {
        try {
            let object = {
                company_id: data?.company_id ? data?.company_id : StorageService?.getCompanyId(),
                lr_id: data?._id,
            }
            if (data?._id) {
                const res = await getDataLrDetails(object);
                if (res?.responseCode === 200) {
                    setLoading(false);
                    setLrDetailsData(res?.data?.lr)
                }
            }

        } catch (error) {
            setLoading(false);
            // throw error;
        }
    }

    const getDetailsOfConsignorData = async (data) => {
        try {
            let object = {
                consignor_id: data?.consignor_id?._id ? data?.consignor_id?._id : data?.consignor_id,
                company_id: data?.company_id ? data?.company_id : StorageService?.getCompanyId(),
            }
            const res = await fetchConsignorDetailsData(object);
            if (!!res) {
                setLoading(false);
                setConsignorDetailsData(res?.data?.consignor);
            }
        } catch (error) {
            setLoading(false);
        }
    }


    const getUserPermission = async () => {
        try {
            const res = await getUserPermissionApi({
                company_id: StorageService.getCompanyId(),
            });
            if (res?.responseCode === 200) {

                setUserSettingPermission(res?.data?.user)

            } else {
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        if (isOpen) {
            setLoading(true);
            // getDetailsOfLrData(isOpen);
            getTableMaterialCategoryListData();
            getUserPermission()
        }
    }, [isOpen])

    useEffect(() => {
        console.log(isOpen)
        if (isOpen?.consignor_id) {
            setLoading(true);
            getDetailsOfConsignorData(isOpen);
        }
    }, [isOpen])

    let partyPointModalProps = {
        isOpen: isOpenPartyPoint,
        closeModal: (e) => setIsOpenPartyPoint(false),
        lrId: lrDetailsData?._id,
        isDetailsData: lrDetailsData,
        companyId: lrDetailsData?.company_id,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: isOpenPartyPoint?.name === 'party_point' ? 'At Party Point' : 'Delivered',
        submitTitle: isOpenPartyPoint?.name === 'party_point' ? 'At Party Point' : 'Delivered',
    }

    const deleteImageFunction = async (data, actionObj) => {
        try {
            let object = {
                lr_id: isOpen?._id,
                file_path: data?.path,
            }
            const res = await deletePodImage(object);
            if (res?.responseCode === 200) {
                setLoading(false);
                if (actionObj?.action === true) {
                    getDetailsOfLrData({ _id: isOpen?._id, company_id: StorageService?.getCompanyId(), })
                    toast.success(`POD file deleted successfully`);
                    setDeletePodFiles(false)
                }
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const podUpdateData = async () => {
        setLoading(true);
        try {
            let object = {
                lr_id: updateDetailsUsingPod?.lr_id,
                company_id: updateDetailsUsingPod?.company_id,
                Po_number: updateDetailsUsingPod?.Po_number,
                invoice_number: updateDetailsUsingPod?.invoice_number,
                sap_invoice_number: updateDetailsUsingPod?.sap_invoice_number,
                pod_number: updateDetailsUsingPod?.pod_number,
                total_qty_in_stn: updateDetailsUsingPod?.total_qty_in_stn,
                total_kot: updateDetailsUsingPod?.total_kot
            }
            const res = await podUpdateDataService(object);
            if (res?.responseCode === 200) {
                setLoading(false);
                toast.success(`POD Lr data updated successfully`);
                setUpdateDetailsUsingPod(false)
            }
        } catch (error) {
            setLoading(false);
        }
    }

    let podRecievedProps = {
        isOpen: isOpenPodReceived,
        closeModal: (e) => setIsOpenPodReceived(false),
        nextModal: (e) => setContinePodReceived(e),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: 'POD Received',
        submitTitle: 'POD Received',
        detailsLrData: lrDetailsData,
        consignorPermissions: consignorDetailsData,
        deleteImage: (e) => deleteImageFunction(e)
    }

    const apiCallingFunction = async (data) => {
        try {
            const res = await podReceivedData(data);
            if (res?.responseCode === 200) {
                setIsOpenPodReceived(false);
                setContinePodReceived(false);
                setLoading(false);
                toast.success(`${res?.responseMessage}`);
                if (res?.data?.pod_status?.status === true) {
                    // if(res?.data?.pod_status?.message){
                    //     toast.success(`${res?.data?.pod_status?.message}`);
                    // }
                    let object = res?.data?.pod_status?.data ? res?.data?.pod_status?.data : {}
                    setUpdateDetailsUsingPod(object)
                }
            } else {
                setLoading(false);
                setIsOpenPodReceived(false);
                setContinePodReceived(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const closeModalFunction = () => {
        setIsOpenPodReceived(false);
        setContinePodReceived(false);
    }

    const continueOnClickHandler = () => {
        let obj = {
            ...continePodReceived,
            pod_flag: 1
        }
        apiCallingFunction(obj);
    }

    const saveOnClickHandler = () => {
        let obj = {
            ...continePodReceived,
            pod_flag: 0
        }
        apiCallingFunction(obj);
    }

    let continuePodRecievedModalProps = {
        isOpen: continePodReceived,
        closeModal: closeModalFunction,
        modalMainClass: "_dashCommon_Modal _smModal",
        cancelButtonTitle: 'Cancel', // 'Save',
        modalTitle: 'POD Received',
        submitTitle: 'POD Received',
        footerPart: true,
        submitTitle: loading ? 'Loading...' : 'Continue',
        disabled: loading,
        continueOnClick: continueOnClickHandler,
        saveOnClick: closeModalFunction, // saveOnClickHandler,
    }

    useEffect(() => {
        if (isOpen) {
            getDetailsOfLrData(isOpen);
        }
    }, [isOpenPartyPoint, isOpenPodReceived, continePodReceived, isOpen]) // isPodStatusEdit

    const handleLrEditAction = () => {
        nextModal({ ...consignorDetailsData, isEditLr: true, lr_id: lrDetailsData?._id });
    }

    const submitUpdateData = async (data) => {
        try {
            const res = await podStatusUpdateData(data);
            if (!!res) {
                getDetailsOfLrData(isOpen);
                toast.success(`Update successfully`);
                setLoading(false);
                setIsPodStatusEdit(false);
            } else {
                setLoading(false);
                setIsPodStatusEdit(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    let podStatusEditProps = {
        isOpen: isPodStatusEdit,
        closeModal: (e) => setIsPodStatusEdit(false),
        nextModal: (e) => submitUpdateData(e),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: 'Update POD Status',
        submitTitle: 'Update POD Status',
        consignorPermissions: consignorDetailsData,
        deleteImage: (e) => deleteImageFunction(e)
    }

    let permissionModalProps = {
        isOpen: permissionModal,
        closeModal: (e) => setPermissionModal(!permissionModal),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Permission",
        submitTitle: "Close",
        message: `You don't have permissions`,
        firstSubmitTitle: 'Close',
        firstSubmitHandler: (e) => setPermissionModal(!permissionModal),
        hideSecondButton: false
    }

    let updateDetailsUsingPodModalProps = {
        isOpen: updateDetailsUsingPod,
        closeModal: (e) => setUpdateDetailsUsingPod(false),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "POD Update",
        submitTitle: "Close",
        columnWisePodFooter: true,
        firstSubmitHandler: (e) => podUpdateData(e),
        secondSubmitHandler: (e) => setUpdateDetailsUsingPod(false),
    }

    const handlePermissionCallTrip = async (link) => {
        await actionPermission({
            company_id: StorageService.getCompanyId(),
            type: constant?.USABILITY_CONFIG_TYPES?.TRIP,
            onSuccess: () => navigate(link),
            setModalConfig
        });
    };

    const handleDeleteImage = async (item) => {
        setDeletePodFiles(item);
    }

    const callbackAction = (action) => {
        const actionMap = {
            freight: () => setIsOpenCharges({ open: true, type: "advance" }),
            claim: () => setIsOpenClaim(true),
            balance: () => setIsOpenCharges({ open: true, type: "balance" }),
            edit: () => setEditLrAmount(true)
        };

        if (actionMap[action]) {
            actionMap[action](); // Run the mapped action
            // setIsOpenFreight(false);
        }
    };

    // CALL BACK ACTION


    const callBackCharge = () => {
        setIsOpenCharges({ open: false, type: "" })
        setIsOpenClaim(false)
        // setIsOpenFreight(true)
        // setActiveTab("addFreight")
        const generateId = () => {
            return `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        };
        getDetailsOfLrData(isOpen);
        setActiveTab(`addFreight_${generateId()}`);
    }

    const submitLeaveModalProps = () => {
        setShowBackModal(false)
        navigate(`/account/branch/details/${lrDetailsData?.branch_id?._id}?type=${constant.m_type.branch}&tab=${3}&search=${lrDetailsData?.branch_id?.branch}&offset=${1}&total_record=${25}`)
    }
    // props start
    let chargeProps = {
        isOpen: isOpenCharge.open,
        closeModal: (e) => setIsOpenCharges({ open: false, type: "" }),
        isOpenCharge: isOpenCharge,
        headerPart: true,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Add Freight",
        submitTitle: "Add Freight",
        cancelButtonTitle: "Send for Approval",
        tripId: lrDetailsData?.trip_id?._id,
        lrDetails: lrDetailsData,
        callBackCharge: callBackCharge,

    };

    let claimProps = {
        isOpen: isOpenClaim,
        closeModal: () => setIsOpenClaim(false),
        headerPart: true,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Add Claim",
        tripId: lrDetailsData?.trip_id?._id,
        lrDetails: lrDetailsData,
        callBackCharge: callBackCharge,
    };

    let addTotalProps = {
        isOpen: editLrAmount,
        closeModal: (e) => {
            setEditLrAmount(false);
        },
        headerPart: false,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Edit Freight Amount",
        submitTitle: "Update Amount",
        tripId: isHandleRowData?.trip_id?._id,
        data: isHandleRowData,
        icon: Images.EDIT,
        callbackTotal: callBackCharge,
    };

    let propsObject = {
        isOpen: deletePodFiles?._id,
        closeModal: () => setDeletePodFiles(false),
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: (e) => deleteImageFunction(deletePodFiles, { action: true }),
        isLoadding: loading,
    }

    let ebillExpProps = {
        isOpen: modalConfig.isOpen,
        closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
        onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
        modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
        headerPart: true,
        floatCrossBtn: true,
        submitTitle: "Send Enquiry",
        messageType: modalConfig.messageType,
        templateId: modalConfig.templateId,
        templateData: modalConfig.templateData
    };

    let storeModelProps = {
        isOpen: imagePreview,
        modalMainClass: '_dashCommon_Modal _mdModal',
        modalTitle: 'Preview',
        submitTitle: 'Preview',
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
        closeModal: (e) => setImagePreview(false),
    }

    let builtyPrintModal = {
        isOpen: format?.lr_id,
        closeModal: (e) => setFormats(false),
        modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
        footerPart: true,
        modalTitle: "Print Lr",
        submitTitle: "Print Lr",
        therdSubmitTitle: "Download",
        format: format,
        confirmBox: (e) => setShowBackModal(true)
    }

    const backModalProps = {
        show: showBackModal,
        closeModal: (e) => setShowBackModal(false),
        title: "Information",
        submitTitle: "Add Format",
        onSubmit: submitLeaveModalProps,
        confirmModal: "confirmModal",
    };

    const submitDeleteLr = async (element) => {
        setLrDeleteLoading(true);
        try {
            let object = {
                lr_id: element?._id ? element?._id : '',
            }
            const res = await deleteLrListData(object);
            if (res?.responseCode == 200) {
                callGetData();
                if (res?.responseMessage) {
                    toast.success(`${res?.responseMessage}`);
                }
                setLrDeleteLoading(false);
                onClose(false);
            } else {
                setLrDeleteLoading(false);
            }
        } catch (error) {
            setLrDeleteLoading(false);
        }
    }

    let propsLrObject = {
        isOpen: isLrDelete,
        closeModal: (e) => setIsLrDelete(false),
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: (e) => submitDeleteLr(isLrDelete),
        isLoadding: lrDeleteloading,
    }

    return (
        <>
            <div className="offcanvas-header lrd-header">
                <h5 className="offcanvas-title"> {loading ? 'Loading...' : lrDetailsData?.lr_number} <span className={masterData?.lr_status[lrDetailsData?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[lrDetailsData?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[lrDetailsData?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[lrDetailsData?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[lrDetailsData?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}>{masterData?.lr_status[lrDetailsData?.lr_status]} </span> </h5>

                <div style={{ display: "flex", marginLeft: 'auto', gap: "10px" }}>
                    {lrDetailsData?.lr_status === 1 && <ButtonForIcon
                        text="Delete"
                        type="button"
                        className="_switchBtn  __animEffect_btn_common"
                        style={{ marginLeft: 'auto' }}
                        onClick={() => setIsLrDelete(lrDetailsData)}
                    >
                        <span className='deleteIcon_avt ex_delete'>
                            <FaRegTrashCan color='red' />
                        </span>
                    </ButtonForIcon>}

                    {!hideEditButton ?
                        <>
                            {
                                (lrPermissions?.edit === 1) ?
                                    <ButtonForIcon
                                        type="button"
                                        className="_switchBtn __animEffect_btn_common"
                                        style={{ marginLeft: 'auto' }}
                                        disabled={loading}
                                        onClick={(e) => handleLrEditAction(e)}
                                        text="Edit"
                                    >
                                        <HiPencil color='' />
                                    </ButtonForIcon>
                                    : <ButtonForIcon type="button" className="_switchBtn  __animEffect_btn_common" style={{ marginLeft: 'auto' }} disabled={loading} onClick={(e) => setPermissionModal(e)} text="Edit">
                                        <HiPencil color='' />
                                    </ButtonForIcon>
                            }
                        </>
                        :
                        <></>
                    }
                    {/* <ButtonForIcon type="button" className="_switchBtn  __animEffect_btn_common" style={{ marginLeft: 'auto' }} onClick={() => navigate("/invoicing/createbillraise", {
                        state: {
                            consignor: lrDetailsData?.consignor_id,
                            branch: lrDetailsData?.branch_id,
                        },
                    })}
                        text="Raise Bill"
                    >
                        <svg
                            className="cross"
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 20 20"
                            fill="none"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M16.5 18.3091H3.5C2.57174 18.3091 1.6815 17.9404 1.02513 17.284C0.368749 16.6276 0 15.7374 0 14.8091V1.75212C0 0.685123 1.056 0.00812271 1.985 0.330123C2.118 0.376123 2.248 0.443123 2.372 0.532123L2.547 0.657123C2.97266 0.95915 3.48188 1.12098 4.0038 1.12008C4.52572 1.11918 5.03438 0.95561 5.459 0.652123C6.05504 0.227937 6.76843 0 7.5 0C8.23157 0 8.94496 0.227937 9.541 0.652123C9.96562 0.95561 10.4743 1.11918 10.9962 1.12008C11.5181 1.12098 12.0273 0.95915 12.453 0.657123L12.628 0.532123C13.621 -0.177877 15 0.532123 15 1.75212V9.30912H18.5C18.6989 9.30912 18.8897 9.38814 19.0303 9.52879C19.171 9.66945 19.25 9.86021 19.25 10.0591V15.5591C19.25 16.2885 18.9603 16.9879 18.4445 17.5037C17.9288 18.0194 17.2293 18.3091 16.5 18.3091ZM15.25 10.8091V15.5591C15.25 15.8906 15.3817 16.2086 15.6161 16.443C15.8505 16.6774 16.1685 16.8091 16.5 16.8091C16.8315 16.8091 17.1495 16.6774 17.3839 16.443C17.6183 16.2086 17.75 15.8906 17.75 15.5591V10.8091H15.25ZM11 6.55912C11 6.36021 10.921 6.16945 10.7803 6.02879C10.6397 5.88814 10.4489 5.80912 10.25 5.80912H4.25C4.05109 5.80912 3.86032 5.88814 3.71967 6.02879C3.57902 6.16945 3.5 6.36021 3.5 6.55912C3.5 6.75804 3.57902 6.9488 3.71967 7.08945C3.86032 7.2301 4.05109 7.30912 4.25 7.30912H10.25C10.4489 7.30912 10.6397 7.2301 10.7803 7.08945C10.921 6.9488 11 6.75804 11 6.55912ZM10 9.55912C10 9.36021 9.92098 9.16945 9.78033 9.02879C9.63968 8.88814 9.44891 8.80912 9.25 8.80912H4.25C4.05109 8.80912 3.86032 8.88814 3.71967 9.02879C3.57902 9.16945 3.5 9.36021 3.5 9.55912C3.5 9.75804 3.57902 9.9488 3.71967 10.0895C3.86032 10.2301 4.05109 10.3091 4.25 10.3091H9.25C9.44891 10.3091 9.63968 10.2301 9.78033 10.0895C9.92098 9.9488 10 9.75804 10 9.55912ZM10.25 11.8091C10.4489 11.8091 10.6397 11.8881 10.7803 12.0288C10.921 12.1694 11 12.3602 11 12.5591C11 12.758 10.921 12.9488 10.7803 13.0895C10.6397 13.2301 10.4489 13.3091 10.25 13.3091H4.25C4.05109 13.3091 3.86032 13.2301 3.71967 13.0895C3.57902 12.9488 3.5 12.758 3.5 12.5591C3.5 12.3602 3.57902 12.1694 3.71967 12.0288C3.86032 11.8881 4.05109 11.8091 4.25 11.8091H10.25Z"
                                fill="black"
                            />
                        </svg>
                    </ButtonForIcon> */}
                    <ButtonForIcon type="button" className="_switchBtn  __animEffect_btn_common" style={{ marginLeft: 'auto' }} onClick={() => {
                        setFormats({ ...format, lr_with_pod: 0, lr_id: lrDetailsData?._id, originalData: lrDetailsData })
                    }}
                        text="Print"
                    >
                        <svg
                            className="cross"
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                        >
                            <path
                                d="M12 12C12.1837 12 12.361 12.0675 12.4983 12.1895C12.6356 12.3116 12.7233 12.4798 12.7448 12.6622L12.75 12.75V15.75C12.75 15.9337 12.6825 16.111 12.5605 16.2483C12.4384 16.3856 12.2702 16.4733 12.0878 16.4948L12 16.5H6C5.8163 16.5 5.639 16.4325 5.50172 16.3105C5.36444 16.1884 5.27674 16.0202 5.25525 15.8378L5.25 15.75V12.75C5.25002 12.5663 5.31747 12.389 5.43954 12.2517C5.56161 12.1144 5.72981 12.0267 5.91225 12.0052L6 12H12ZM14.25 5.25C14.8467 5.25 15.419 5.48705 15.841 5.90901C16.2629 6.33097 16.5 6.90326 16.5 7.5V12.75C16.5 13.1478 16.342 13.5294 16.0607 13.8107C15.7794 14.092 15.3978 14.25 15 14.25H14.25V12C14.25 11.6022 14.092 11.2206 13.8107 10.9393C13.5294 10.658 13.1478 10.5 12.75 10.5H5.25C4.85218 10.5 4.47064 10.658 4.18934 10.9393C3.90804 11.2206 3.75 11.6022 3.75 12V14.25H3C2.60218 14.25 2.22064 14.092 1.93934 13.8107C1.65804 13.5294 1.5 13.1478 1.5 12.75V7.5C1.5 6.90326 1.73705 6.33097 2.15901 5.90901C2.58097 5.48705 3.15326 5.25 3.75 5.25H14.25ZM12.75 6.75H11.25C11.0588 6.75021 10.875 6.82341 10.736 6.95464C10.597 7.08586 10.5133 7.26521 10.5021 7.45605C10.4909 7.64688 10.553 7.83478 10.6757 7.98137C10.7984 8.12796 10.9724 8.22217 11.1623 8.24475L11.25 8.25H12.75C12.9412 8.24979 13.125 8.17659 13.264 8.04536C13.403 7.91414 13.4867 7.73479 13.4979 7.54395C13.5091 7.35312 13.447 7.16522 13.3243 7.01863C13.2016 6.87204 13.0276 6.77783 12.8378 6.75525L12.75 6.75ZM12.75 1.5C12.9489 1.5 13.1397 1.57902 13.2803 1.71967C13.421 1.86032 13.5 2.05109 13.5 2.25V3.75H4.5V2.25C4.5 2.05109 4.57902 1.86032 4.71967 1.71967C4.86032 1.57902 5.05109 1.5 5.25 1.5H12.75Z"
                                fill="black"
                            />
                        </svg>
                    </ButtonForIcon>
                    <ButtonForIcon type="button" className="_switchBtn  __animEffect_btn_common" style={{ marginLeft: 'auto' }} onClick={() => onClose(!isOpen)} text="Close">
                        <svg
                            className="cross"
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 15 15"
                            fill="none">
                            <path
                                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                fill="black"
                            />
                        </svg>
                    </ButtonForIcon></div>


            </div>


            <nav className='lrNavigate'>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button className="nav-link active" id="nav-lrDetail-tab" data-bs-toggle="tab" data-bs-target="#nav-lrDetail" type="button" role="tab" aria-controls="nav-lrDetail" aria-selected="true" onClick={() => setActiveTab("")}> <span>LR Detail</span> </button>

                    <button className="nav-link" id="nav-lrStatus-tab" data-bs-toggle="tab" data-bs-target="#nav-lrStatus" type="button" role="tab" aria-controls="nav-lrStatus" aria-selected="false" onClick={() => setActiveTab("")}> <span>LR Status</span> </button>
                    <button className="nav-link" id="nav-lrfreight-tab" data-bs-toggle="tab" data-bs-target="#nav-lrfreight" type="button" role="tab" aria-controls="nav-lrfreight" aria-selected="false" onClick={() => setActiveTab("lrfreight")}> <span>LR Freight</span> </button>


                    {ewayBillStatusDetails ? <button className="nav-link" id="nav-ewayBillStatus-tab" data-bs-toggle="tab" data-bs-target="#nav-ewayBillStatus" type="button" role="tab" aria-controls="nav-ewayBillStatus" aria-selected="false"> <span> Eway Status </span> </button> : <></>}

                </div>
            </nav>

            <div className="tab-content" id="nav-tabContent" style={{ flex: '1' }}>
                <div className="tab-pane fade show active" id="nav-lrDetail" role="tabpanel" aria-labelledby="nav-lrDetail-tab" tabIndex="0">
                    <div className='offcanvas-body __addNewLrBody' style={{ justifyContent: loading ? 'center' : '' }}>
                        {loading ?
                            <div className='h-100 position-relative justify-content-center align-items-center d-flex'> <Loading /> </div>
                            :
                            (lrDetailsData && consignorDetailsData) &&
                            <LrDetailsPage
                                lrData={lrDetailsData}
                                permissions={consignorDetailsData}
                                materialCategoryList={materialCategoryList}
                                ewayBillStatusDetails={ewayBillStatusDetails}
                            />
                        }
                    </div>

                    {/* <div className='offcanvas-footer'>
                        {!hideEditButton ?
                            <>
                                {
                                    (lrPermissions?.edit === 1) ?
                                        <button className='_addComm_btn _sameWid' disabled={loading} onClick={(e) => handleLrEditAction(e)}>Edit</button>
                                        : <button className='_addComm_btn _sameWid' disabled={loading} onClick={(e) => setPermissionModal(!permissionModal)}>Edit</button>
                                }
                            </>
                            :
                            <></>
                        }
                        <button className='_cancel_btn _avPointer' onClick={(e) => onClose(false)} >Cancel</button>
                    </div> */}
                </div>

                <div className="tab-pane fade" id="nav-lrStatus" role="tabpanel" aria-labelledby="nav-lrStatus-tab" tabIndex="0" >
                    <div className='offcanvas-body'>
                        <div className='lrFlow_rls'>
                            <div className='_inrLr_flow'>
                                <ul>
                                    {
                                        lrDetailsData?.lr_process?.length > 0 && lrDetailsData?.lr_process?.map((el, ind) => {
                                            return (
                                                <li className={`lrsCommon ${el?.status === 1 ? 'lrs_active' : ''}`} key={ind}>
                                                    <div className='stepsBx'>
                                                        <div className='stepIcon'>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                                                <circle cx="8.1076" cy="8.1076" r="8.1076" fill="#1450EC" />
                                                                <path d="M3.47461 7.722L6.5637 10.8111L12.7404 4.6329" stroke="white" strokeWidth="1.45609" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </div>

                                                        <div className='stepInfos'>
                                                            <h4> {el?.name} <span className='_stpDateTime'> | {utils.localDateWithTime(el?.date)} </span>
                                                                {/* <button className='_editStep'>Edit</button>  */}
                                                            </h4>
                                                            {el?.type === 'intransit' && <div className='_transitDetail'>
                                                                <div className='_stLr_truckNo' onClick={(e) => navigate(`/trip/addtrip/dispatched/${lrDetailsData?.trip_id?._id}`)}> <a className='_avPointer'>{lrDetailsData?.trip_id?.trip_number} </a> </div> | <span className='_stLr_truckNo'> {el?.vehicle_no} </span> <span className={(el?.vehicle_ownership === 'Own') ? '_trkMark _lrDelivered_status' : '_stmarket'}> {el?.vehicle_ownership} Driver</span> <span className='_stLr_truckType'> {el?.lorry_type} </span>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>

                            <div className='_stpsBtn_bx'>
                                {childsUser?.create === 1 && lrDetailsData?.lr_status === 1 && !createTripBtn && (
                                    <button
                                        className="_lrdSteps_btn"
                                        onClick={() => {
                                            setLrDetialsFrom(lrDetailsData);
                                            handlePermissionCallTrip('/trip/addtrip/createtrip2');
                                        }}
                                    >
                                        <span>Create Trip</span>
                                    </button>
                                )}
                                {
                                    lrDetailsData?.lr_status === 3 && (
                                        <button className='_lrdSteps_btn' onClick={() => setIsOpenPartyPoint({ name: 'party_point' })}> <span> Mark At Party Point </span> </button>
                                    )
                                }
                                {
                                    lrDetailsData?.lr_status === 4 && (
                                        <button className='_lrdSteps_btn' onClick={() => setIsOpenPartyPoint({ name: 'delivered' })}> <span> Mark Delivered </span> </button>
                                    )
                                }
                                {
                                    lrDetailsData?.lr_status === 5 && (
                                        <button className='_lrdSteps_btn' onClick={() => navigate("/invoicing/createbillraise", {
                                            state: {
                                                consignor: lrDetailsData?.consignor_id,
                                                branch: lrDetailsData?.branch_id,
                                            },
                                        })}> <span> Raise Bill </span> </button>
                                    )
                                }
                            </div>
                        </div>

                        <div className='podFlow_rls'>
                            <div className='_inrPod_flow'>
                                <div className='_podHead'><p>POD Status</p> <span className={lrDetailsData?.pod_status === 1 ? '_pendingStat' : '_receivedStat'}>{masterData?.pod_status[lrDetailsData?.pod_status]} </span></div>
                                {/* <div className='_podHead mt-2'><p> {getTodayDate2(lrDetailsData?.pod_date)} </p> {lrDetailsData?.pod_status > 1 && <span onClick={(e) => setIsPodStatusEdit({ ...lrDetailsData })}> Edit </span>} </div> */}
                                {/* <div className='_podHead mt-2'><p> {utils.firstLetterCapital(lrDetailsData?.pod_remark)} </p> </div> */}
                                {/* <div className='d-flex'>
                                    {
                                        lrDetailsData?.pod_file?.length > 0 && lrDetailsData?.pod_file?.map((el, ind) => {
                                            return (
                                                <div key={ind} className='hgt_wdt_avt mt-2'>
                                                    <img src={`${masterData?.s3_url}${el?.path}`} alt={ind} />
                                                </div>
                                            )
                                        })
                                    }
                                    {loading ? <div className='flex_div mt-2'> Loading... </div> : <div className='flex_div'>
                                        <div className='singleDiv mt-2'>
                                            <input
                                                type="file"
                                                name='file'
                                                id='_file'
                                                hidden
                                            // onChange={(e) => handleFileChange(e)}
                                            />
                                            <label htmlFor='_file'> &nbsp; <RiAddLargeFill className='_avPointer' /> </label>
                                        </div>
                                    </div>}

                                </div> */}
                            </div>

                            {(lrDetailsData?.pod_status === 1 && lrDetailsData?.lr_status >= 3) &&
                                <div className='_stpsBtn_bx'>
                                    <button className='_podSteps_btn' onClick={(e) => setIsOpenPodReceived({ ...lrDetailsData })}> <span> Add POD </span> </button>
                                </div>
                            }
                            {
                                lrDetailsData?.pod_status > 1 &&
                                <div className='_stpsBtn_bx'>
                                    <button className='_podSteps_btn' onClick={(e) => setIsPodStatusEdit({ ...lrDetailsData })}> <span> Edit POD Received </span> </button>
                                </div>
                            }
                            {(consignorDetailsData?.permission_at_pod?.attachment?.view === 1) &&
                                <>
                                    <div className='img_fnex_src'>
                                        {/* <div className="_divForth"> */}
                                        {
                                            lrDetailsData?.pod_file?.length > 0 &&
                                            lrDetailsData?.pod_file?.map((el, ind) => {
                                                return (
                                                    <div className='__fileMl_bxs' key={el?.path + ind}>
                                                        <div className='__upFileDetail'>
                                                            <div className='__uplImg'>
                                                                {
                                                                    el?.path?.split('.')?.at(-1) === 'pdf' ?
                                                                        <span className='pdf_clsr-ct'>
                                                                            <BsFillFileEarmarkPdfFill />
                                                                        </span>
                                                                        : (el?.path?.split('.')?.at(-1) === 'xlsx' || el?.path?.split('.')?.at(-1) === 'xls' || el?.path?.split('.')?.at(-1) === 'txt') ?
                                                                            <span className='xlsx_clsr-ct'>
                                                                                <BsFiletypeXlsx />
                                                                            </span> :
                                                                            <span className='__uplImg-ct'>
                                                                                <FaRegImage />
                                                                            </span>
                                                                }
                                                                <p>{`${el?.filename}`}</p>
                                                            </div>
                                                            <div className='__uplIcons _avPointer'>

                                                                <MdOutlineRemoveRedEye onClick={() => setImagePreview({ url: `${masterData?.s3_url}${el?.path}`, preview: true })} style={{ fontSize: '18px', color: 'blue' }} />

                                                                <a href={`${masterData?.s3_url}${el?.path}`} target='_blank' className='__upDownload_ico' style={{ fontSize: '18px' }}>
                                                                    <MdOutlineFileDownload />
                                                                </a>
                                                                <span className='__upCross_ico' style={{ fontSize: '18px' }} onClick={(e) => handleDeleteImage(el)}>
                                                                    <RxCross2 />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                        {/* </div> */}
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="nav-lrfreight" role="tabpanel" aria-labelledby="nav-lrfreight-tab" tabIndex="0" >
                    <div className='offcanvas-body'>
                        {activeTab && <LrFreight callbackAction={callbackAction} lrDetails={isOpen} callBackCharge={callBackCharge} activeTab={activeTab} setHandleRowData={setHandleRowData} permissions={consignorDetailsData} />}
                    </div>
                </div>
                {ewayBillStatusDetails ?
                    <div className="tab-pane fade show active" id="nav-lrDetail" role="tabpanel" aria-labelledby="nav-lrDetail-tab" tabIndex="0">
                        <div className='offcanvas-body'>
                            {loading ?
                                <div className='p-3'>
                                    Loading ...
                                </div>
                                :
                                <TimeLine timeLineArray={lrDetailsData?.eway_timeline} />
                            }
                        </div>

                        <div className='offcanvas-footer'>
                            <button className='_cancel_btn _avPointer' onClick={(e) => onClose(false)} > Close </button>
                        </div>
                    </div>
                    :
                    <></>
                }
            </div>

            {
                isOpenPartyPoint?.name
                && (
                    <AtPartyPointModal {...partyPointModalProps} />
                )
            }

            {
                isOpenPodReceived?._id
                && (
                    <PodRecievedModal {...podRecievedProps} />
                )
            }

            {
                continePodReceived?.date
                && (
                    <ContinuePodRecievedModal {...continuePodRecievedModalProps} />
                )
            }

            {
                isPodStatusEdit?._id
                && (
                    <EditPodStatus {...podStatusEditProps} />
                )
            }
            {
                permissionModal
                && (
                    <PermissionModal {...permissionModalProps} />
                )
            }

            {
                updateDetailsUsingPod?.lr_id
                && (
                    <UpdateLrDetailsUsingPod {...updateDetailsUsingPodModalProps} />
                )
            }

            {
                deletePodFiles?._id && (
                    <CommonModal {...propsObject}>
                        <p className='p-3'> Are you sure you want to delete POD file <br /> {deletePodFiles?.filename} ? </p>
                    </CommonModal>
                )
            }

            {
                modalConfig.isOpen && <EbillExtentionModal

                    {...ebillExpProps}

                />
            }

            {
                imagePreview?.preview
                && (
                    <ImagePreview {...storeModelProps} />
                )
            }
            {isOpenCharge?.open && <AddChargesForInvoice {...chargeProps} />}
            {isOpenClaim && <AddClaimForInvoice {...claimProps} />}
            {/* {editLrAmount && <EditConsignorFInvoice {...addTotalProps} />} */}
            {editLrAmount && <EditConsignorFreight {...addTotalProps} />}
            {format?.lr_id
                && (
                    <InvoiceLrPodModal {...builtyPrintModal} />
                )
            }
            {showBackModal && (
                <ConfirmModalFor {...backModalProps}>
                    <>
                        <p className="_confirmPrx">You don't have any format.</p>
                    </>
                </ConfirmModalFor>
            )}

            {
                isLrDelete?._id && (
                    <CommonModal {...propsLrObject}>
                        <p className='p-3'> Are you sure you want to delete {isLrDelete?.lr_number} ? </p>
                    </CommonModal>
                )
            }
        </ >
    )
}

export default LrDetailModal; // React.memo()